//import React from 'react'
import { Outlet } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Header from "./components/Header";
import Footer from "./components/Footer";

const App = () => {
  return (
    <>
      <ToastContainer position="top-center" autoClose="3000" />
      <Header />
      <main style={{ fontSize: "1.05rem", lineHeight: "150%" }}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default App;
